import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { BookMarked } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FFF5FA] dark:bg-[#1E1529]">
        <div className="flex items-center gap-3 text-[#7A6A8C]">
          <BookMarked className="w-5 h-5 animate-pulse" />
          <span className="font-serif-display text-lg">LitMap</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
